import React from 'react';

import { Link } from 'react-router-dom';
import Logo from '../../Common/components/Logo';
import images from '../../Common/Images';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
import localStorage from '../../Common/LocalStorage';

let strings = new LocalizedStrings(translations);

const ResetPassword = props => {
    if (localStorage.getFromStorage('lang') === undefined) {
        localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
    }

    strings.setLanguage(localStorage.getFromStorage('lang'));

    return (
        <div className="container">
            <div className="login-container row" onKeyPress={props.pressEnterHandler}>
                <div className="col-6 offset-3">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="logo">
                                <Logo url={images.LOGIN_LOGO} />
                            </div>
                        </div>
                        <div className="col-12 text-center">
                            <h1 className="login-title">{strings.reset_success}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 qf-mb-30">
                            <div className="form-container text-center">
                                <h5 className="title">{strings.check_email}</h5>
                                <Link to={StaticRoutePaths.LOGIN}>
                                    <input className="login-button input" id="login" value={strings.login} type="submit" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/customModules/Login/components/Reset-password-login.js